import { Sheet } from "../types/api/sheet";

/**
 * Date à afficher pour une fiche : sa date de mise en ligne.
 *
 * `updatedAt` bouge à chaque édition, y compris sur un brouillon non encore
 * publié : il ne sert plus que de repli pour les fiches servies par un cache
 * (IndexedDB, `/all-data`) rempli avant l'ajout de `publishedAt`.
 */
export const getSheetDisplayDate = (
  sheet: Pick<Sheet, "updatedAt" | "publishedAt">
) => sheet.publishedAt ?? sheet.updatedAt;
